<template>
    <div>
        <div class="hidden lg:block dropdown-wrapper relative text-gray-500">
            <a
                href="#"
                class="dropdown-btn text-gray-500 -mx-4 lg:mx-0 px-4 py-2 font-semibold mt-1 lg:mt-0 block outline-none hover:bg-gray-200 hover:text-gray-800"
                >{{ title }}
                <span class="hidden lg:inline">
                    <i class="ml-1 fa fa-chevron-down font-hairline"></i>
                </span>
            </a>
            <div class="dropdown hidden absolute left-0 bg-white shadow-lg text-gray-600 bg-gray-200 py-2 w-64 z-50">
                <a
                    v-for="link in links"
                    :key="link.href"
                    :href="link.href"
                    class="block text-gray-500 px-3 py-2 hover:text-gray-800"
                >
                    {{ link.title }}
                </a>
            </div>
        </div>
        <div class="lg:hidden relative text-gray-500">
            <span class="-mx-4 lg:mx-0 px-4 py-2 font-semibold mt-1 lg:mt-0 block"
                >{{ title }}
                <span class="hidden lg:inline">
                    <i class="ml-1 fa fa-chevron-down font-hairline"></i>
                </span>
            </span>
            <div class="text-gray-500">
                <a
                    v-for="link in links"
                    :key="link.href"
                    :href="link.href"
                    class="block text-gray-500 px-4 py-1 hover:text-gray-800"
                >
                    {{ link.title }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        links: {
            type: Array,
            default: () => {
                return [];
            }
        }
    }
};
</script>

<style scoped>
.dropdown-wrapper:hover .dropdown {
    display: block;
    @apply bg-gray-200;
}

.dropdown-wrapper:hover .dropdown-btn {
    @apply bg-gray-200;
    @apply text-gray-800;
}
</style>
